import React, { FunctionComponent, useCallback } from 'react';
import { useStore } from 'effector-react';
import posts, { getList } from '@stores/posts';
import PostCard from '@components/PostCard';
import { Spin, Pagination, Empty } from 'antd';
import css from './PostsList.module.less';
import useScrollTopPage from '@hooks/useScrollTopPage';

interface PostsListProps {}

const PostsList: FunctionComponent<PostsListProps> = () => {
  const { list, pagination, preloaders } = useStore(posts);

  const paginationChange = useCallback((current?: number, pageSize?: number) => {
    localStorage.setItem('postsPageSize', `${pageSize}`);
    getList({ pagination: { current, pageSize } });
  }, []);

  useScrollTopPage(pagination);

  if (!list.length && !preloaders.getList) {
    return <Empty />;
  }

  return (
    <div>
      <div className={css.paginationContainer}>
        <Pagination
          {...pagination}
          showSizeChanger
          showQuickJumper
          onChange={paginationChange}
        />
      </div>
      <Spin spinning={!!preloaders.getList}>
        <div className={css.root}>
          {list.map((post) => (
            <PostCard
              post={post}
              key={post.id}
              isBlocking={preloaders.block === `block_${post.id}`}
              isUnblocking={preloaders.unblock === `unblock_${post.id}`}
              isHidingPost={preloaders.hidePost === `hidePost_${post.id}`}
              isUnhidingPost={preloaders.unhidePost === `unhidePost_${post.id}`}
              isSettingFacePost={preloaders.facePost === `facePost_${post.id}`}
              isRemovingFacePost={preloaders.removefacePost === `removefacePost_${post.id}`}
            />
          ))}
        </div>
      </Spin>
      <div className={css.paginationContainer}>
        <Pagination
          {...pagination}
          showSizeChanger
          onChange={paginationChange}
        />
      </div>
    </div>
  );
};

export default PostsList;
